import { MintWidget } from "@/app/drop/actions/mint-widget"
import { DropStatus, type MinimalDrop } from "@anaconda/core/drop/types"
import { usePhaseStatus } from "../order/use-phase-status"
import { AddDropToCalendarButton } from "./add-drop-to-calendar-button"
import { TradeOnSecondaryLink } from "./trade-on-secondary"

type DropActionProps = {
  drop: MinimalDrop
  className?: string
  phaseNumber: number
}

/**
 * DropAction component - renders appropriate action button for each phase.
 *
 * NOTE: This component does NOT create its own DropScopeProvider.
 * It relies on the scope provided by drop-layout-client.tsx at the layout level.
 * Creating additional scopes here would cause duplicate molecule instances and effects.
 */
export function DropAction({ drop, className, phaseNumber }: DropActionProps) {
  const status = usePhaseStatus(phaseNumber)

  if (status === DropStatus.Upcoming) {
    return <AddDropToCalendarButton drop={drop} className={className} />
  }

  if (status === DropStatus.Ended) {
    return <TradeOnSecondaryLink drop={drop} className={className} />
  }

  return <MintWidget drop={drop} className={className} />
}
